module.exports = __webpack_public_path__ + "dist/assets/img/G.aad211fa.svg";